module.exports = __webpack_public_path__ + "static/img/backgroundPayCenter.fd288a30.jpg";